import styled from "styled-components/macro";

import { TitleH1 } from "../../styles/sharedStyles";

export const Section = styled.section<{ bgImage?: string }>`
  width: 100%;
  height: 550px;
  background-image: ${({ bgImage }) => bgImage ? `url(${bgImage})` : "none"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 30px;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 80px;
    
  @media (max-width: 1439px) {
    height: 540px;
    margin-bottom: 40px;
  }

  @media (max-width: 979px) {
    padding: 40px 12px 0;
    border-radius: 0;
  }
`;

export const Title = styled(TitleH1)``

export const Desc = styled.p`
  font-size: 22px;
  line-height: 140%;
  letter-spacing: -0.02em;
  max-width: 648px;
  text-align: center;
  margin-bottom: 36px;

  @media (max-width: 1439px) {
    font-size: 20px;
  }

  @media (max-width: 1439px) {
    font-size: 16px;
    margin-bottom: 24px;
  }
`

